module.exports = __webpack_public_path__ + "img/иконки-20.9d7cb42f.svg";